import { render, staticRenderFns } from "./FeaturedCardBody.vue?vue&type=template&id=6eba7c91&"
import script from "./FeaturedCardBody.vue?vue&type=script&lang=js&"
export * from "./FeaturedCardBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports